import * as React from 'react';
import Flex, { Props as FlexProps } from '../Flex/Flex';

export interface Props extends FlexProps { }

/**
 * Modal body wrapper with preset padding.
 */
const ModalBody: React.FunctionComponent<Props> = (props: Props) => {
  return (
    <Flex grow { ...props } />
  );
};

ModalBody.defaultProps = {
  padding: 'x10',
};

export default ModalBody;
